import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Typography, Paper } from "@mui/material";

const BackdropComp = ({ isLoading  , message = "Loading please wait..."}) => {
  return (
    <Box>
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
          <Paper sx={{display:'flex', justifyContent:"space-between" ,minWidth:'200px', padding:'15px 20px' }}>
          <CircularProgress sx={{color:'#95a5a6' , }} />
              <Typography variant="body2" textAlign='center' gutterBottom sx={{flex:"1", marginLeft:"10px" , paddingTop:'10px'}} >{message}</Typography>
            </Paper>
            
          </Backdrop>
    </Box>
  );
};
export default BackdropComp;